import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getPersonChildren as getPersonChildrenApi } from "../api/kindergartenApi";
import Person from "../models/Person/Person";

interface PersonState {
  children: Person[];
}

let initialState: PersonState = {
  children: [],
};

export const getChildren = createAsyncThunk(
  "person/getChildren",
  async () => {
    const response = await getPersonChildrenApi();
    return response;
  }
);

const personSlice = createSlice({
  name: "person",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getChildren.fulfilled, (state, { payload }) => {
      state.children = payload;
    });
  },
});

export default personSlice.reducer;
